import script from "./CapsuleCodePopup.vue?vue&type=script&setup=true&lang=js"
export * from "./CapsuleCodePopup.vue?vue&type=script&setup=true&lang=js"

import "./CapsuleCodePopup.vue?vue&type=style&index=0&id=e8fd1b02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8fd1b02"]])

export default __exports__